import { QueueListIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const SectionsFeature: FeatureMetadata = {
  id: "classSections",
  moduleName: "academics",

  navigation: {
    label: "Sections",
    path: "/class-sections",
    icon: QueueListIcon,
    order: 3,
  },

  route: {
    path: "/class-sections",
    element: lazy(() => import("./pages/Sections")),
  },

  // Reuse the existing permission family already used by Classes.
  permissions: {
    view: "Academics.ClassesSections.view",
    create: "Academics.ClassesSections.create",
    edit: "Academics.ClassesSections.edit",
    delete: "Academics.ClassesSections.delete",
  },

  readiness: "live",
};
